import { defineMessages } from 'react-intl'

const app = defineMessages({
  'app.text': {
    id: 'app.text',
    defaultMessage: 'app text description',
    description: '文本',
  },
})

const common = defineMessages({
  settingProceededSuccessfully: {
    id: 'common.settingProceededSuccessfully',
    defaultMessage: 'This setting has been proceeded successfully.',
    description: '设置操作成功',
  },
})

export default {
  ...app,
  ...common,
}
